import React from 'react'
import PropTypes from 'prop-types'
import marked from 'marked'

const Markdown = ({ source, secondary }) =>
  <section
    className={`${secondary ? 'secondary-color' : 'white'} lh-title f4 f3-ns mw7 center`}
    dangerouslySetInnerHTML={{ __html: marked(source) }}
  />

Markdown.propTypes = {
  source: PropTypes.string.isRequired,
  secondary: PropTypes.bool
}

export default Markdown



// WEBPACK FOOTER //
// ./src/components/Markdown/Markdown.js